export class Organization {
  id: number;
  organizationName: string;
  certificationId: string;
  description: string;
  adminId: string;
  adminEmail: string;
  adminFullName: string;
}
